import { render, staticRenderFns } from "./SirenCharts.vue?vue&type=template&id=1313d4c1"
import script from "./SirenCharts.vue?vue&type=script&lang=js"
export * from "./SirenCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports